import { render, staticRenderFns } from "./ChartJs.vue?vue&type=template&id=947d3f74"
import script from "./ChartJs.vue?vue&type=script&lang=js"
export * from "./ChartJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports